export default {
    LOGIN: () => '/auth/login',
    REGISTER: () => '/auth/register',
};
